import { Box, Link, Typography } from "@mui/material";

import { useFormTranslator } from "../../../../hooks/useFormTranslator";
import { CustomerLocation } from "../../../../models/customer/CustomerLocation";

interface CustomerLocationFieldProps {
    field: keyof CustomerLocation;
    link?: string;
    value?: string;
    enum?: boolean;
    italic?: boolean;
}

export function CustomerLocationField({
    field,
    link,
    value,
    enum: isEnum = false,
    italic = false,
}: CustomerLocationFieldProps) {
    const translator = useFormTranslator("customerLocation");

    const internalValue =
        isEnum && value ? translator.getField(field).getEnum(value) : value;

    return (
        <Box>
            <Typography variant="subtitle1">
                {translator.getField(field).getName()}
            </Typography>
            {internalValue ? (
                link ? (
                    <Link
                        variant="body2"
                        href={link}
                        style={{
                            fontStyle: italic ? "italic" : "initial",
                        }}
                    >
                        {internalValue}
                    </Link>
                ) : (
                    <Typography
                        variant="body2"
                        style={{ fontStyle: italic ? "italic" : "initial" }}
                    >
                        {internalValue}
                    </Typography>
                )
            ) : (
                <Typography variant="body2">-</Typography>
            )}
        </Box>
    );
}
